import { Table, TableBody, TableHeader } from '@library/components/table';
import type { FormattedMemberChangeLogs } from '@library/types/members/memberChangeLogs';
import { Loading } from '@library/components/Loading';
import { MEMBERS_CHANGE_LOG_HEADER } from '@bo-constants/member/memberChangeLogs';
import { MemberChangeLogRow } from '@bo-components/members/memberChangeLogs';
import { NoResults } from '@library/components/NoResults';

export interface MemberChangeLogTableProps {
  changeLogs: FormattedMemberChangeLogs | undefined;
  isError: boolean;
  isFetching: boolean;
}

export const MemberChangeLogTable = ({
  changeLogs,
  isError,
  isFetching
}: MemberChangeLogTableProps) => {
  if (isFetching) {
    return <Loading loadingMessage="Loading change logs" />;
  }

  const isChangeLogsNotFound = isError || !changeLogs?.length;

  if (isChangeLogsNotFound) {
    return (
      <NoResults
        className="m-0 w-full"
        dataTestId="no-member-change-log-results"
        label="There are no change logs for this member"
      />
    );
  }

  return (
    <Table
      className="border-soFresh-140 rounded-lg border p-0"
      dataTestId="members-search-results"
    >
      <TableHeader headers={MEMBERS_CHANGE_LOG_HEADER} className="pr-2" />
      <TableBody className="max-h-[calc(100vh-194px)] overflow-y-scroll">
        {changeLogs.map((changeLog) => (
          <MemberChangeLogRow key={changeLog.id} changeLog={changeLog} />
        ))}
      </TableBody>
    </Table>
  );
};
